import TrustPilotContainer from './trust_pilot_container';

export default TrustPilotContainer;
